<template>
  <div>
    <info v-if="type==='1'" :center-id="centerId" @typeChange="typeChange"  @change="periodItemIdChange"></info>
    <center-info v-else-if="type==='2'" @change="centerIdChange"></center-info>
    <item v-else @typeChange="typeChange" :center-id="centerId" :period-item-id="periodItemId"></item>
  </div>
</template>

<script>

  import Info from './visitRate/Info'
  import CenterInfo from './visitRate/Center'
  import Item from './visitRate/Item'
  import {  mapGetters } from 'vuex'
  export default {
    name: 'VisitRate',
    components: { Info,CenterInfo,Item },
    data(){
      return {
        type:'1',
        centerId:'',
        periodItemId:'',
      }
    },
    mounted(){
      this.centerIdChange(this.userInfo().centerId)
    },
    methods:{
      ...mapGetters(["userInfo"]),
      centerIdChange(centerId){
        this.centerId = centerId
        this.typeChange('1')
      },
      periodItemIdChange(periodItemId){
        this.periodItemId = periodItemId
        this.typeChange('3')
      },

      typeChange(type){
        this.type=type
      }
    }
  }
</script>

<style scoped>

</style>